<template>
  <div>
    <h2>留言板(为服务器留下祈祷吧OvO)</h2>
    <el-row>
      <el-col :span="4">
        你的署名ID：
        <el-input
          placeholder="请输入你的署名ID……"
          v-model="userid"
          maxlength="180"
          style="width: 50%"
        >
        </el-input>
      </el-col>
      <el-col :span="10">
        你的留言内容：
        <el-input
          placeholder="请输入留言内容……"
          v-model="msginput"
          maxlength="180"
          style="width: 80%"
          >
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="success" plain @click="addmsg">点击留言</el-button>
      </el-col>
    </el-row>


    <template>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="id"
          label="楼层数"
          width="180">
        </el-table-column>
        <el-table-column
          prop="username"
          label="名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="msg"
          label="信息">
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
    export default {
      data(){
        return{
          userid : '',
          msginput: '',
          tableData: [],
        }
      },
      methods: {
        addmsg(){

          this.$alert('留言成功！', '留言', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: '留言任务完成'
              });
            }
          });

          this.$http.get("http://doc.gtea.icu/notesql/add.php?username="+this.username+"&msg="+this.msginput+"&skey="+this.skey).then(res => {
            console.log(res);
          });
          this.msginput = '';

          this.$http.get("http://doc.gtea.icu/notesql/getlist.php").then(res => {
            this.tableData = res.data;
            console.log(res);
          });

        }
      },
      created() {
        this.$http.get("http://doc.gtea.icu/notesql/getlist.php").then(res => {
          this.tableData = res.data;
          console.log(res);
        });
      },
        name: "msgbox"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/msgbox.vue